import { render, staticRenderFns } from "./ResponsivePicture.vue?vue&type=template&id=12692346&"
import script from "./ResponsivePicture.vue?vue&type=script&lang=js&"
export * from "./ResponsivePicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports